/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnumTypeModel } from '../../models/enum-type-model';

export interface MasterDataEnumTypeModelGet$Params {
}

export function masterDataEnumTypeModelGet(http: HttpClient, rootUrl: string, params?: MasterDataEnumTypeModelGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<EnumTypeModel>> {
  const rb = new RequestBuilder(rootUrl, masterDataEnumTypeModelGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<EnumTypeModel>;
    })
  );
}

masterDataEnumTypeModelGet.PATH = '/MasterData/EnumTypeModel';
